import { render, staticRenderFns } from "./sciencefigures.vue?vue&type=template&id=414cdf80&scoped=true&"
import script from "./sciencefigures.vue?vue&type=script&lang=js&"
export * from "./sciencefigures.vue?vue&type=script&lang=js&"
import style0 from "./sciencefigures.vue?vue&type=style&index=0&id=414cdf80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414cdf80",
  null
  
)

export default component.exports